/*
 * @Author: Cursor AI
 * @Date: 2026-01-29
 * @Description: 分享弹窗相关多语言配置
 * @FilePath: /weryai-web/locales/modules/share.ts
 */
export default {
    zh: {
            title: '分享',
            copyLink: '复制链接',
            copy: '复制',
            copied: '已复制',
            share: '分享',
            shareToX: '分享到X',
            shareToFacebook: '分享到Facebook',
            shareToInstagram: '分享到Instagram',
            copySuccess: '链接已复制到剪贴板',
            copyFailed: '复制失败，请手动复制',
            instagramCopyHint: '链接已复制，请在Instagram中粘贴分享',
            img_share_desc:'用 AI 生成你想象中的任何画面 ｜Wery AI',
            video_share_desc:'让想法直接变成高质量视频 ｜Wery AI',
            music_share_desc:'用 AI 生成音乐与声音内容 ｜Wery AI',
            podcast_share_desc:'用 AI 生成双人播客与对话音频 ｜Wery AI',
            charc_share_desc:'创建并对话 AI 角色，探索不同人格 ｜Wery AI',
            shareToTikTok: '分享到TikTok',
            shareToDiscord: '分享到Discord',
    },
    en: {
            title: 'Share',
            copyLink: 'Copy Link',
            copy: 'Copy',
            copied: 'Copied',
            share: 'Share',
            shareToX: 'Share to X',
            shareToFacebook: 'Share to Facebook',
            shareToInstagram: 'Share to Instagram',
            copySuccess: 'Link copied to clipboard',
            copyFailed: 'Copy failed, please copy manually',
            instagramCopyHint: 'Link copied, please paste and share in Instagram',
            img_share_desc:'Create any image you imagine with AI ｜Wery AI',
            video_share_desc:'Turn ideas into high-quality video instantly ｜Wery AI',
            music_share_desc:'Generate music and audio with AI ｜Wery AI',
            podcast_share_desc:'Generate podcast conversations and dialogue audio with AI ｜Wery AI',
            charc_share_desc:'Create and chat with AI characters, explore personalities ｜Wery AI',
            shareToTikTok: 'Share to TikTok',
            shareToDiscord: 'Share to Discord',
    },
    ja: {
            title: '共有',
            copyLink: 'リンクをコピー',
            copy: 'コピー',
            copied: 'コピー済み',
            share: '共有',
            shareToX: 'Xで共有',
            shareToFacebook: 'Facebookで共有',
            shareToInstagram: 'Instagramで共有',
            copySuccess: 'リンクがクリップボードにコピーされました',
            copyFailed: 'コピーに失敗しました。手動でコピーしてください',
            instagramCopyHint: 'リンクがコピーされました。Instagramで貼り付けて共有してください',
            img_share_desc:'AIで想像したあらゆる画像を生成 ｜Wery AI',
            video_share_desc:'アイデアを高品質な動画に変える ｜Wery AI',
            music_share_desc:'AIで音楽と音声を生成 ｜Wery AI',
            podcast_share_desc:'AIでポッドキャスト会話と対話音声を生成 ｜Wery AI',
            charc_share_desc:'AIキャラクターを作って会話し、多様な人格を探る ｜Wery AI',
            shareToTikTok: 'TikTokで共有',
            shareToDiscord: 'Discordで共有',
    },
    ko: {
            title: '공유',
            copyLink: '링크 복사',
            copy: '복사',
            copied: '복사됨',
            share: '공유',
            shareToX: 'X에 공유',
            shareToFacebook: 'Facebook에 공유',
            shareToInstagram: 'Instagram에 공유',
            copySuccess: '링크가 클립보드에 복사되었습니다',
            copyFailed: '복사 실패, 수동으로 복사해 주세요',
            instagramCopyHint: '링크가 복사되었습니다. Instagram에서 붙여넣기하여 공유하세요',
            img_share_desc:'AI로 상상한 모든 이미지를 생성 ｜Wery AI',
            video_share_desc:'아이디어를 고품질 영상으로 바로 변환 ｜Wery AI',
            music_share_desc:'AI로 음악과 사운드를 생성 ｜Wery AI',
            podcast_share_desc:'AI로 팟캐스트 대화와 음성 콘텐츠를 생성 ｜Wery AI',
            charc_share_desc:'AI 캐릭터를 만들고 대화하며 다양한 성격을 탐험 ｜Wery AI',
            shareToTikTok: 'TikTok에 공유',
            shareToDiscord: 'Discord에 공유',
    },
    tw: {
            title: '分享',
            copyLink: '複製連結',
            copy: '複製',
            copied: '已複製',
            share: '分享',
            shareToX: '分享到X',
            shareToFacebook: '分享到Facebook',
            shareToInstagram: '分享到Instagram',
            copySuccess: '連結已複製到剪貼簿',
            copyFailed: '複製失敗，請手動複製',
            instagramCopyHint: '連結已複製，請在Instagram中貼上分享',
            img_share_desc:'用 AI 生成你想像中的任何畫面 ｜Wery AI',
            video_share_desc:'讓想法直接變成高品質影片 ｜Wery AI',
            music_share_desc:'用 AI 生成音樂與聲音內容 ｜Wery AI',
            podcast_share_desc:'用 AI 生成雙人播客與對話音訊 ｜Wery AI',
            charc_share_desc:'建立並對話 AI 角色，探索不同人格 ｜Wery AI',
            shareToTikTok: '分享到TikTok',
            shareToDiscord: '分享到Discord',
    },
    es: {
            title: 'Compartir',
            copyLink: 'Copiar enlace',
            copy: 'Copiar',
            copied: 'Copiado',
            share: 'Compartir',
            shareToX: 'Compartir en X',
            shareToFacebook: 'Compartir en Facebook',
            shareToInstagram: 'Compartir en Instagram',
            copySuccess: 'Enlace copiado al portapapeles',
            copyFailed: 'Error al copiar, cópielo manualmente',
            instagramCopyHint: 'Enlace copiado, pégalo y comparte en Instagram',
            img_share_desc:'Genera cualquier imagen que imagines con IA ｜Wery AI',
            video_share_desc:'Convierte ideas en vídeos de alta calidad al instante ｜Wery AI',
            music_share_desc:'Genera música y audio con IA ｜Wery AI',
            podcast_share_desc:'Genera podcasts conversacionales y audio de diálogo con IA ｜Wery AI',
            charc_share_desc:'Crea y conversa con personajes de IA, explora distintas personalidades ｜Wery AI',
            shareToTikTok: 'Compartir en TikTok',
            shareToDiscord: 'Compartir en Discord',
    },
    fr: {
            title: 'Partager',
            copyLink: 'Copier le lien',
            copy: 'Copier',
            copied: 'Copié',
            share: 'Partager',
            shareToX: 'Partager sur X',
            shareToFacebook: 'Partager sur Facebook',
            shareToInstagram: 'Partager sur Instagram',
            copySuccess: 'Lien copié dans le presse-papiers',
            copyFailed: 'Échec de la copie, veuillez copier manuellement',
            instagramCopyHint: 'Lien copié, collez-le et partagez sur Instagram',
            img_share_desc:'Générez toutes les images que vous imaginez avec l’IA ｜Wery AI',
            video_share_desc:'Transformez vos idées en vidéos de haute qualité ｜Wery AI',
            music_share_desc:'Générez musique et audio avec l’IA ｜Wery AI',
            podcast_share_desc:'Générez des podcasts conversationnels et des dialogues audio avec l’IA ｜Wery AI',
            charc_share_desc:'Créez et discutez avec des personnages IA, explorez différentes personnalités ｜Wery AI',
            shareToTikTok: 'Partager sur TikTok',
            shareToDiscord: 'Partager sur Discord',
    },
    de: {
            title: 'Teilen',
            copyLink: 'Link kopieren',
            copy: 'Kopieren',
            copied: 'Kopiert',
            share: 'Teilen',
            shareToX: 'Auf X teilen',
            shareToFacebook: 'Auf Facebook teilen',
            shareToInstagram: 'Auf Instagram teilen',
            copySuccess: 'Link in die Zwischenablage kopiert',
            copyFailed: 'Kopieren fehlgeschlagen, bitte manuell kopieren',
            instagramCopyHint: 'Link kopiert, fügen Sie ihn ein und teilen Sie auf Instagram',
            img_share_desc:'Erstelle jedes Bild, das du dir vorstellst, mit KI ｜Wery AI',
            video_share_desc:'Verwandle Ideen direkt in hochwertige Videos ｜Wery AI',
            music_share_desc:'Erzeuge Musik und Audio mit KI ｜Wery AI',
            podcast_share_desc:'Erzeuge Podcast-Gespraeche und Dialog-Audio mit KI ｜Wery AI',
            charc_share_desc:'Erstelle KI-Charaktere und chatte, entdecke verschiedene Persönlichkeiten ｜Wery AI',
            shareToTikTok: 'Auf TikTok teilen',
            shareToDiscord: 'Auf Discord teilen',
    },
    ru: {
            title: 'Поделиться',
            copyLink: 'Копировать ссылку',
            copy: 'Копировать',
            copied: 'Скопировано',
            share: 'Поделиться',
            shareToX: 'Поделиться в X',
            shareToFacebook: 'Поделиться в Facebook',
            shareToInstagram: 'Поделиться в Instagram',
            copySuccess: 'Ссылка скопирована в буфер обмена',
            copyFailed: 'Ошибка копирования, скопируйте вручную',
            instagramCopyHint: 'Ссылка скопирована, вставьте и поделитесь в Instagram',
            img_share_desc:'Создавайте любые изображения с помощью ИИ ｜Wery AI',
            video_share_desc:'Превращайте идеи в качественные видео ｜Wery AI',
            music_share_desc:'Создавайте музыку и звук с помощью ИИ ｜Wery AI',
            podcast_share_desc:'Создавайте подкасты и диалоговое аудио с помощью ИИ ｜Wery AI',
            charc_share_desc:'Создавайте и общайтесь с ИИ‑персонажами, исследуйте разные личности ｜Wery AI',
            shareToTikTok: 'Поделиться в TikTok',
            shareToDiscord: 'Поделиться в Discord',
    },
    pt: {
            title: 'Compartilhar',
            copyLink: 'Copiar link',
            copy: 'Copiar',
            copied: 'Copiado',
            share: 'Compartilhar',
            shareToX: 'Compartilhar no X',
            shareToFacebook: 'Compartilhar no Facebook',
            shareToInstagram: 'Compartilhar no Instagram',
            copySuccess: 'Link copiado para a área de transferência',
            copyFailed: 'Falha ao copiar, copie manualmente',
            instagramCopyHint: 'Link copiado, cole e compartilhe no Instagram',
            img_share_desc:'Gere qualquer imagem que você imaginar com IA ｜Wery AI',
            video_share_desc:'Transforme ideias em vídeos de alta qualidade ｜Wery AI',
            music_share_desc:'Gere música e áudio com IA ｜Wery AI',
            podcast_share_desc:'Gere podcasts conversacionais e áudio de diálogo com IA ｜Wery AI',
            charc_share_desc:'Crie e converse com personagens de IA, explore diferentes personalidades ｜Wery AI',
            shareToTikTok: 'Compartilhar no TikTok',
            shareToDiscord: 'Compartilhar no Discord',
    },
    it: {
            title: 'Condividi',
            copyLink: 'Copia link',
            copy: 'Copia',
            copied: 'Copiato',
            share: 'Condividi',
            shareToX: 'Condividi su X',
            shareToFacebook: 'Condividi su Facebook',
            shareToInstagram: 'Condividi su Instagram',
            copySuccess: 'Link copiato negli appunti',
            copyFailed: 'Copia fallita, copia manualmente',
            instagramCopyHint: 'Link copiato, incollalo e condividi su Instagram',
            img_share_desc:'Genera qualsiasi immagine che immagini con l’IA ｜Wery AI',
            video_share_desc:'Trasforma le idee in video di alta qualità ｜Wery AI',
            music_share_desc:'Genera musica e audio con l’IA ｜Wery AI',
            podcast_share_desc:'Genera podcast conversazionali e audio di dialogo con l’IA ｜Wery AI',
            charc_share_desc:'Crea e chatta con personaggi IA, esplora diverse personalità ｜Wery AI',
            shareToTikTok: 'Condividi su TikTok',
            shareToDiscord: 'Condividi su Discord',
    },
    ar: {
            title: 'مشاركة',
            copyLink: 'نسخ الرابط',
            copy: 'نسخ',
            copied: 'تم النسخ',
            share: 'مشاركة',
            shareToX: 'مشاركة على X',
            shareToFacebook: 'مشاركة على Facebook',
            shareToInstagram: 'مشاركة على Instagram',
            copySuccess: 'تم نسخ الرابط إلى الحافظة',
            copyFailed: 'فشل النسخ، يرجى النسخ يدويًا',
            instagramCopyHint: 'تم نسخ الرابط، الصقه وشاركه على Instagram',
            img_share_desc:'أنشئ أي صورة تتخيلها بالذكاء الاصطناعي ｜Wery AI',
            video_share_desc:'حوّل أفكارك إلى فيديوهات عالية الجودة ｜Wery AI',
            music_share_desc:'أنشئ موسيقى ومحتوى صوتي بالذكاء الاصطناعي ｜Wery AI',
            podcast_share_desc:'أنشئ حلقات بودكاست ومحتوى حواريًا صوتيًا بالذكاء الاصطناعي ｜Wery AI',
            charc_share_desc:'أنشئ شخصيات ذكاء اصطناعي وتحدث معها لاستكشاف شخصيات مختلفة ｜Wery AI',
            shareToTikTok: 'شارك في TikTok',
            shareToDiscord: 'شارك في Discord',
        },
    th: {
            title: 'แชร์',
            copyLink: 'คัดลอกลิงก์',
            copy: 'คัดลอก',
            copied: 'คัดลอกแล้ว',
            share: 'แชร์',
            shareToX: 'แชร์ไปยัง X',
            shareToFacebook: 'แชร์ไปยัง Facebook',
            shareToInstagram: 'แชร์ไปยัง Instagram',
            copySuccess: 'คัดลอกลิงก์ไปยังคลิปบอร์ดแล้ว',
            copyFailed: 'คัดลอกไม่สำเร็จ โปรดคัดลอกด้วยตนเอง',
            instagramCopyHint: 'คัดลอกลิงก์แล้ว วางและแชร์บน Instagram',
            img_share_desc:'สร้างภาพที่คุณจินตนาการได้ด้วย AI ｜Wery AI',
            video_share_desc:'เปลี่ยนไอเดียให้เป็นวิดีโอคุณภาพสูงทันที ｜Wery AI',
            music_share_desc:'สร้างเพลงและเสียงด้วย AI ｜Wery AI',
            podcast_share_desc:'สร้างพอดแคสต์บทสนทนาและเสียงพูดคุยด้วย AI ｜Wery AI',
            charc_share_desc:'สร้างและพูดคุยกับตัวละคร AI สำรวจบุคลิกที่หลากหลาย ｜Wery AI',
            shareToTikTok: 'แชร์ไปยัง TikTok',
            shareToDiscord: 'แชร์ไปยัง Discord',
    },
    id: {
            title: 'Bagikan',
            copyLink: 'Salin tautan',
            copy: 'Salin',
            copied: 'Disalin',
            share: 'Bagikan',
            shareToX: 'Bagikan ke X',
            shareToFacebook: 'Bagikan ke Facebook',
            shareToInstagram: 'Bagikan ke Instagram',
            copySuccess: 'Tautan disalin ke clipboard',
            copyFailed: 'Gagal menyalin, silakan salin secara manual',
            instagramCopyHint: 'Tautan disalin, tempel dan bagikan di Instagram',
            img_share_desc:'Buat gambar apa pun yang kamu bayangkan dengan AI ｜Wery AI',
            video_share_desc:'Ubah ide menjadi video berkualitas tinggi ｜Wery AI',
            music_share_desc:'Buat musik dan audio dengan AI ｜Wery AI',
            podcast_share_desc:'Buat podcast percakapan dan audio dialog dengan AI ｜Wery AI',
            charc_share_desc:'Buat dan ngobrol dengan karakter AI, jelajahi berbagai kepribadian ｜Wery AI',
            shareToTikTok: 'Bagikan ke TikTok',
            shareToDiscord: 'Bagikan ke Discord',
    },
    tr: {
            title: 'Paylaş',
            copyLink: 'Bağlantıyı kopyala',
            copy: 'Kopyala',
            copied: 'Kopyalandı',
            share: 'Paylaş',
            shareToX: "X'te paylaş",
            shareToFacebook: "Facebook'ta paylaş",
            shareToInstagram: "Instagram'da paylaş",
            copySuccess: 'Bağlantı panoya kopyalandı',
            copyFailed: 'Kopyalama başarısız, manuel olarak kopyalayın',
            instagramCopyHint: "Bağlantı kopyalandı, yapıştırın ve Instagram'da paylaşın",  
            img_share_desc:'Hayal ettiğin her görüntüyü AI ile üret ｜Wery AI',
            video_share_desc:'Fikirleri anında yüksek kaliteli videoya dönüştür ｜Wery AI',
            music_share_desc:'AI ile müzik ve ses üret ｜Wery AI',
            podcast_share_desc:'AI ile podcast konusmalari ve diyalog sesleri uret ｜Wery AI',
            charc_share_desc:'AI karakterleri oluştur, sohbet et, farklı kişilikleri keşfet ｜Wery AI',
            shareToTikTok: 'X\'te paylaş',
            shareToDiscord: 'Discord\'ta paylaş',
    },
    pl: {
            title: 'Udostępnij',
            copyLink: 'Kopiuj link',
            copy: 'Kopiuj',
            copied: 'Skopiowano',
            share: 'Udostępnij',
            shareToX: 'Udostępnij na X',
            shareToFacebook: 'Udostępnij na Facebooku',
            shareToInstagram: 'Udostępnij na Instagramie',
            copySuccess: 'Link skopiowany do schowka',
            copyFailed: 'Kopiowanie nie powiodło się, skopiuj ręcznie',
            instagramCopyHint: 'Link skopiowany, wklej i udostępnij na Instagramie',
            img_share_desc:'Twórz dowolne obrazy, które sobie wyobrazisz, z pomocą AI ｜Wery AI',
            video_share_desc:'Zamieniaj pomysły w wysokiej jakości wideo ｜Wery AI',
            music_share_desc:'Twórz muzykę i audio z pomocą AI ｜Wery AI',
            podcast_share_desc:'Twórz podcasty konwersacyjne i dialogi audio z pomocą AI ｜Wery AI',
            charc_share_desc:'Twórz i rozmawiaj z postaciami AI, odkrywaj różne osobowości ｜Wery AI',
            shareToTikTok: 'Udostępnij na TikTok',
            shareToDiscord: 'Udostępnij na Discord',
    },
    da: {
            title: 'Del',
            copyLink: 'Kopiér link',
            copy: 'Kopiér',
            copied: 'Kopieret',
            share: 'Del',
            shareToX: 'Del på X',
            shareToFacebook: 'Del på Facebook',
            shareToInstagram: 'Del på Instagram',
            copySuccess: 'Link kopieret til udklipsholder',
            copyFailed: 'Kopiering mislykkedes, kopiér manuelt',
            instagramCopyHint: 'Link kopieret, indsæt og del på Instagram',
            img_share_desc:'Skab ethvert billede du kan forestille dig med AI ｜Wery AI',
            video_share_desc:'Gør idéer til videoer i høj kvalitet ｜Wery AI',
            music_share_desc:'Skab musik og lyd med AI ｜Wery AI',
            podcast_share_desc:'Skab podcast-samtaler og dialoglyd med AI ｜Wery AI',
            charc_share_desc:'Skab og chat med AI‑karakterer, udforsk forskellige personligheder ｜Wery AI',
            shareToTikTok: 'Del på TikTok',
            shareToDiscord: 'Del på Discord',
    },
    no: {
            title: 'Del',
            copyLink: 'Kopier lenke',
            copy: 'Kopier',
            copied: 'Kopiert',
            share: 'Del',
            shareToX: 'Del på X',
            shareToFacebook: 'Del på Facebook',
            shareToInstagram: 'Del på Instagram',
            copySuccess: 'Lenke kopiert til utklippstavlen',
            copyFailed: 'Kopiering mislyktes, kopier manuelt',
            instagramCopyHint: 'Lenke kopiert, lim inn og del på Instagram',
            img_share_desc:'Lag ethvert bilde du kan forestille deg med AI ｜Wery AI',
            video_share_desc:'Gjør ideer om til videoer i høy kvalitet ｜Wery AI',
            music_share_desc:'Lag musikk og lyd med AI ｜Wery AI',
            podcast_share_desc:'Lag podkast-samtaler og dialoglyd med AI ｜Wery AI',
            charc_share_desc:'Lag og chat med AI‑figurer, utforsk ulike personligheter ｜Wery AI',
            shareToTikTok: 'Del på TikTok',
            shareToDiscord: 'Del på Discord',
    },
    nl: {
            title: 'Delen',
            copyLink: 'Link kopiëren',
            copy: 'Kopiëren',
            copied: 'Gekopieerd',
            share: 'Delen',
            shareToX: 'Delen op X',
            shareToFacebook: 'Delen op Facebook',
            shareToInstagram: 'Delen op Instagram',
            copySuccess: 'Link gekopieerd naar klembord',
            copyFailed: 'Kopiëren mislukt, kopieer handmatig',
            instagramCopyHint: 'Link gekopieerd, plak en deel op Instagram',
            img_share_desc:'Maak elke afbeelding die je je kunt voorstellen met AI ｜Wery AI',
            video_share_desc:'Zet ideeën om in video’s van hoge kwaliteit ｜Wery AI',
            music_share_desc:'Maak muziek en audio met AI ｜Wery AI',
            podcast_share_desc:'Maak podcastgesprekken en dialoogaudio met AI ｜Wery AI',
            charc_share_desc:'Maak en chat met AI‑personages, ontdek verschillende persoonlijkheden ｜Wery AI',
            shareToTikTok: 'Delen op TikTok',
            shareToDiscord: 'Delen op Discord',
    },
}
